import { texts } from '@/lib/texts';
import { THEME_PREFS, useTheme, type ThemePref } from '@/lib/theme';

/**
 * Переключатель темы «Авто / Светлая / Тёмная» (ADR-21). `Авто` следует за системной
 * настройкой, ручной выбор сохраняется в localStorage и переживает перезагрузку.
 */
export function ThemeSwitch({
  className = '',
  touch = false,
}: {
  className?: string;
  /** Раунд 4, V9: на телефоне кнопки не меньше 44 px по высоте */
  touch?: boolean;
}) {
  const { pref, setPref } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label={texts.theme.label}
      className={`border-border flex rounded-lg border p-0.5 ${className}`}
    >
      {THEME_PREFS.map((option: ThemePref) => {
        const active = pref === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setPref(option)}
            className={[
              'flex-1 rounded-md px-2 py-1 text-xs font-semibold transition',
              touch ? 'min-h-10 sm:min-h-0' : '',
              active ? 'bg-accent/15 text-accent-dark' : 'text-muted hover:bg-surface-2',
            ].join(' ')}
          >
            {texts.theme[option]}
          </button>
        );
      })}
    </div>
  );
}
